import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useTable, useSortBy, useFilters } from "react-table";
import CustomInput from "./CustomInput";


window.Date.prototype.isValid = function() {
  // An invalid date object returns NaN for getTime() and NaN is the only
  // object not strictly equal to itself.
  // eslint-disable-next-line
  return this.getTime() === this.getTime();
};

const ColumnFilter = ({ column: { filterValue, setFilter, filter } }) => {
  return (
    <CustomInput
      value={filterValue || ""}
      onChange={e => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${filter ? filter : ""}...`}
    />
  );
};

/*
  Render every cell EXCEPT the unique cyberface cell if there is no cyberface
 */
function checkRender(header,val){
    return !(header === "UniqueCyberface" && val === "false");
}

/**
 * As in the previous versions, any react table needs colums where at the core we have a field Header, and accessor
 * As in the previous versions, a react table has data that consist of an array of JSONs
 */
const ReactTable = ({ columns, data }) => {
  // functions to run when a column is filtered depending on the type
  const filterTypes = {
    year: (rows, id, filterValue) => {
      return rows.filter(row => {
        const rowValue = row.values[id];
        return rowValue !== undefined &&
          Number(filterValue) &&
          new Date(rowValue) &&
          new Date(rowValue).isValid()
          ? new Date(rowValue).getFullYear() === Number(filterValue)
          : true;
      });
    },
    text: (rows, id, filterValue) => {
      return rows.filter(row => {
        const rowValue = row.values[id];
        return rowValue !== undefined
          ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
          : true;
      });
    }
  };
  const defaultColumn = {
    // Let's set up our default Filter UI
    Filter: ColumnFilter
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes
    },
    // hook for filters
    useFilters,
    // hook for sorting
    useSortBy
  );
  console.log(defaultColumn);
  return (
    <Table bordered {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, i) => {
              // three new addition to column: isSorted, isSortedDesc, getSortByToggleProps
              const {
                render,
                getHeaderProps,
                isSorted,
                isSortedDesc,
                getSortByToggleProps,
                // filter,
                canFilter
              } = column;
              const extraClass = isSorted
                ? isSortedDesc
                  ? "desc"
                  : "asc"
                : "";
              return (
                <th
                  key={`th-${i}`}
                  className={extraClass}
                  // getHeaderProps now receives a function
                >
                  <div {...getHeaderProps(getSortByToggleProps())}>
                    {render("Header")}
                  </div>
                  {/* Render the columns filter UI */}
                  <div>{canFilter ? render("Filter") : null}</div>
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps({
               
            })}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps({
               })}>{checkRender(cell.column.Header,cell.value) ? cell.render("Cell") : ""}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};


export default ReactTable;
